import { render } from "./ClinicTemplateTab.vue?vue&type=template&id=a71c10f2&scoped=true"
import script from "./ClinicTemplateTab.vue?vue&type=script&lang=js"
export * from "./ClinicTemplateTab.vue?vue&type=script&lang=js"

import "./ClinicTemplateTab.vue?vue&type=style&index=0&id=a71c10f2&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a71c10f2"]])

export default __exports__